
import React from 'react';
import ConditionPageTemplate from './ConditionPageTemplate';

const HairThinning = () => {
  const treatments = [
    {
      name: "PRF Hair Restoration",
      href: "/treatments/prf",
      description: "Platelet-rich fibrin injections to stimulate growth",
      price: "$499",
      memberPrice: "$399"
    },
    {
      name: "Scalp Boosters",
      href: "/treatments/scalp-boosters",
      description: "Medical-grade hydration for scalp health",
      price: "$349",
      memberPrice: "$269"
    },
    {
      name: "IV Therapy (Biotin Drip)",
      href: "/treatments/iv-therapy",
      description: "Targeted nutrients for hair and scalp wellness",
      price: "$199",
      memberPrice: "$149"
    },
    {
      name: "Keravive Treatment",
      href: "/treatments/keravive",
      description: "Deep scalp cleansing and nourishment",
      price: "$399",
      memberPrice: "$299"
    }
  ];

  return (
    <ConditionPageTemplate
      title="Hair Thinning"
      subtitle="Glow Starts at the Root"
      description="We treat hair thinning and poor scalp circulation with growth factor-rich therapies and medical-grade hydration. Best for pattern hair loss, thinning hair, poor scalp health, and circulation issues."
      treatments={treatments}
      beforeAfterText="Recommended 3–6 sessions with follow-up maintenance every 3 months."
    />
  );
};

export default HairThinning;
